export default __webpack_public_path__ + "static/media/461.607d3eba.jpg";